import React, { Component, ErrorInfo } from 'react';
import * as Sentry from '@sentry/browser';

interface Props {
    children: React.ReactNode;
    fallback: React.ReactNode;
    logError?: boolean;
}

interface State {
    hasError: boolean;
}

// If you wrap a component with an Error Boundary, if an exception is thrown by that component,
// then this will catch it and allow you to handle it
export default class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
    };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (this.props.logError) {
            console.error('Uncaught error:', error, errorInfo);
        }
        Sentry.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}
